import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';

import { TextField } from 'redux-form-material-ui';

import { Col, Row } from 'react-flexbox-grid';

const ResetPasswordForm = props => {
    const { handleSubmit, pristine, reset, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Paper zIndex={1}>
                <div>
                    <Row>
                        <Col xs={12} style={{padding:20}}>
                            <Field
                                validationErrors={props.errors}
                                floatingLabelText="Passwort"
                                name="password"
                                component={TextField}
                                type="password"
                                style={{ width: '100%' }}
                                label="Passwort"
                            />
                            <br />
                            <Field
                                validationErrors={props.errors}
                                floatingLabelText="Passwort wiederholen"
                                name="password_confirmation"
                                component={TextField}
                                type="password"
                                style={{ width: '100%' }}
                                label="Passwort wiederholen"
                            />
                        </Col>
                    </Row>
                </div>
            </Paper>
            <br />
            <Row>
                <Col xs={12}>
                    <Row end="xs">
                        <Col xs={6}>
                            <RaisedButton
                                label="Speichern"
                                primary={true}
                                type="submit"
                                disabled={props.isFetching}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </form>
    );
};

export default reduxForm({
    form: 'reset_password_form', // a unique identifier for this form
})(ResetPasswordForm);
